import React from 'react';
import { IconInfoCircle, IconChevronDown } from '@tabler/icons';
import { Container } from './styles';

interface StatusSelectProps {
  animal: any;
  canEdit: boolean;
  [x: string]: any;
}

const StatusSelect: React.FC<StatusSelectProps> = ({
  animal,
  canEdit,
  ...rest
}) => {
  const selectOptions = [
    { value: 'ativo', label: 'Ativo' },
    { value: 'abatido', label: 'Abatido' },
    { value: 'vendido', label: 'Vendido' },
    { value: 'morto', label: 'Morto' },
  ];

  return (
    <Container
      style={{
        background:
          animal.estado === 'ativo'
            ? 'var(--info-transparent)'
            : 'var(--danger-transparent)',
      }}
    >
      <IconInfoCircle
        size={25}
        color={animal.estado === 'ativo' ? 'var(--info)' : 'var(--danger)'}
        style={{ marginLeft: 20 }}
      />

      <select
        style={{
          color: animal.estado === 'ativo' ? 'var(--info)' : 'var(--danger)',
        }}
        disabled={!canEdit}
        {...rest}
      >
        {selectOptions.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>

      {canEdit && (
        <button
          style={{
            background:
              animal.estado === 'ativo' ? 'var(--info)' : 'var(--danger)',
          }}
        >
          <IconChevronDown size={25} />
        </button>
      )}
    </Container>
  );
};

export default StatusSelect;
